import { ApiClient } from '@center-technologies/shared-api-clients';

export interface DeleteRelationshipParams {
  relationshipId: string;
}

export interface DeleteRelationshipResult {
  success: boolean;
  error?: string;
}

export async function deleteRelationship(
  graphClient: ApiClient,
  params: DeleteRelationshipParams
): Promise<DeleteRelationshipResult> {
  try {
    await graphClient.delete(`/relationships/${params.relationshipId}`);
    
    return {
      success: true
    };
  } catch (error: any) {
    console.error('Failed to delete relationship:', error);
    return {
      success: false,
      error: error?.message || 'Failed to delete relationship'
    };
  }
}